import styled, { css } from 'styled-components';

const displayFlex = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const BerkeleyStdNormal = css`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: 0.5px;
`;

export const TaxWrapper = styled.div`
  border: solid 1px #ffffff;
  background-color: #ffffff;
`;

export const DownloadPDF = styled(TaxWrapper)`
  position: relative;
  height: ${props => props.height || '218px'};
`;

export const VanguardImage = styled.img`
  position: absolute;
  right: -1px;
  bottom: -1px;
`;

export const ContributionWrapper = styled.div`
  margin: auto;
  color: #022737;
  ${BerkeleyStdNormal};
  height: 100%;
  ${displayFlex};
  padding: 30px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    padding: 20px;
  }
`;
